import { useCallback } from "react";

import useAccountMetadata from "./useAccountMetadata";
import FeatureFlag, { FlagGetter, getFeature } from "../FeatureFlag";

export default function useFeatureFlags(): FlagGetter {
  const accountMetadata = useAccountMetadata();

  return useCallback(
    (featureFlag: FeatureFlag) => {
      if (!accountMetadata.loaded) {
        return false;
      }

      return getFeature(accountMetadata, featureFlag);
    },
    [accountMetadata],
  );
}
